import { render } from "./RefundModal.vue?vue&type=template&id=5befd402"
import script from "./RefundModal.vue?vue&type=script&lang=ts"
export * from "./RefundModal.vue?vue&type=script&lang=ts"
script.render = render

export default script